import React from 'react';
import { LayoutGrid, ShoppingBag, CalendarDays, AlertTriangle } from 'lucide-react';
import {
  MES_COMMANDES_QUICK_VIEW,
  MES_COMMANDES_PRESTATIONS_RDV_FILTER_LABEL,
  getMesCommandesVisibleQuickFilters,
} from '../../utils/mesCommandesMixedUxCore';

const FILTER_DEFS = {
  [MES_COMMANDES_QUICK_VIEW.ALL]: { label: 'Tout', Icon: LayoutGrid },
  [MES_COMMANDES_QUICK_VIEW.COMMANDES]: { label: 'Commandes', Icon: ShoppingBag },
  [MES_COMMANDES_QUICK_VIEW.RDV]: {
    label: MES_COMMANDES_PRESTATIONS_RDV_FILTER_LABEL,
    Icon: CalendarDays,
  },
  [MES_COMMANDES_QUICK_VIEW.ACTIONS]: { label: 'Actions requises', Icon: AlertTriangle, warn: true },
};

export default function MesCommandesMaquetteToolbar({ activeId, onChange, counts, capabilities = null }) {
  const visibleIds = getMesCommandesVisibleQuickFilters(
    capabilities?.loaded
      ? capabilities
      : { loaded: false, productsEnabled: true, servicesEnabled: true },
  );

  return (
    <div
      className="flex flex-wrap gap-2 p-2 rounded-2xl bg-white border border-gray-200 shadow-sm"
      role="group"
      aria-label="Filtres rapides"
    >
      {visibleIds.map((id) => {
        const def = FILTER_DEFS[id];
        if (!def) return null;
        const { label, Icon, warn } = def;
        const active = activeId === id;
        const count = counts[id] ?? 0;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            aria-pressed={active}
            className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-semibold rounded-xl border transition ${
              active
                ? warn
                  ? 'bg-amber-500 text-white border-amber-500 shadow-md'
                  : 'bg-violet-600 text-white border-violet-600 shadow-md'
                : 'bg-gray-50 text-gray-700 border-gray-200 hover:bg-white hover:border-violet-200'
            }`}
          >
            <Icon className={`h-4 w-4 flex-shrink-0 ${active ? 'text-white' : warn ? 'text-amber-600' : 'text-violet-600'}`} />
            {label}
            <span
              className={`tabular-nums text-xs min-w-[1.25rem] px-1.5 py-0.5 rounded-full text-center ${
                active ? 'bg-black/15 text-inherit' : 'bg-white text-gray-600 border border-gray-200'
              }`}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
